type Props = {
  heading: string
  children: JSX.Element
}

export const ProgramFeatureContentLabelGroup = ({
  heading,
  children,
}: Props): JSX.Element => (
  <>
    <div className="text-[2.5vw] lg:text-[0.9vw] text-[#666666]">{heading}</div>
    <div className="mt-[2.5vw] lg:mt-[1.1vw]">{children}</div>
  </>
)
